export const blockIconsFileDownloadForOffline = (
	<span className='material-symbols-outlined'>download_for_offline</span>
);
